import { nextPage, previousPageRestored } from '../../redux/slices/downloadCenterSlice';

// This hook manages pagination logic for the Download Center, 
// including determining if next/previous pages are available and handling page navigation actions.

const useDownloadCenterPagination = ({ activeFolder, activeFolderPage, dispatch, isLoadingFiles, loadFolderPage, paginationHistory, }) => {

  const hasNextPage = !!activeFolderPage.continuationToken; // The !! means "convert to boolean"
  const hasPreviousPage = (paginationHistory[activeFolder]?.length || 0) > 0; // Check if there's history for the active folder and if it has any entries

  const handleNextPage = async () => {
    if (!activeFolder || !hasNextPage || isLoadingFiles) return; 
    dispatch(nextPage({ folderName: activeFolder, currentPage: activeFolderPage })); 
    await loadFolderPage(activeFolder, activeFolderPage.continuationToken); // Load the next page using the continuation token from the current page
  };

  const handlePreviousPage = async () => {
    if (!activeFolder || !hasPreviousPage || isLoadingFiles) return;
    dispatch(previousPageRestored(activeFolder)); // Restore the previous page from history
  };

  return { handleNextPage, handlePreviousPage, hasNextPage, hasPreviousPage, };
};

export default useDownloadCenterPagination;
